import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { createContext, useEffect } from 'react';
import isString from "lodash/isString";
import uniq from "lodash/uniq";
import { error } from '@jutro/logger';
import { getConfigValue } from '@jutro/config';
import { getTokenByKey, setToken, removeTokenByKey } from './AuthTokenStorage';
import { OKTA_NOT_FOUND } from './errorcodes/errorcodes';
import { useAuthState } from './AuthStateProvider';
export const AuthContext = createContext();
export const AuthContextProvider = ({
  children
}) => {
  var _authService$_oktaAut, _authService$_oktaAut3, _authService$_oktaAut4;
  const _useAuthState = useAuthState(),
    authState = _useAuthState.authState,
    authService = _useAuthState.authService;
  const tokenManager = authService === null || authService === void 0 ? void 0 : (_authService$_oktaAut = authService._oktaAuth) === null || _authService$_oktaAut === void 0 ? void 0 : _authService$_oktaAut.tokenManager;
  const basenameUri = getConfigValue('JUTRO_ROUTER_BASENAME', '');
  useEffect(() => {
    var _authService$getAcces, _authService$getIdTok;
    authService === null || authService === void 0 ? void 0 : (_authService$getAcces = authService.getAccessToken) === null || _authService$getAcces === void 0 ? void 0 : _authService$getAcces.call(authService).then(result => {
      setToken('accessToken', result);
    });
    authService === null || authService === void 0 ? void 0 : (_authService$getIdTok = authService.getIdToken) === null || _authService$getIdTok === void 0 ? void 0 : _authService$getIdTok.call(authService).then(result => {
      setToken('idToken', result);
    });
    subscribeTokenManager();
    return unSubscribeTokenManager;
  }, [authService]);
  const subscribeTokenManager = () => {
    const autoRenew = getConfigValue('JUTRO_AUTH_AUTO_RENEW', true);
    tokenManager === null || tokenManager === void 0 ? void 0 : tokenManager.on('expired', key => {
      removeTokenByKey(key);
      if (!autoRenew) {
        logout();
      }
    });
    tokenManager === null || tokenManager === void 0 ? void 0 : tokenManager.on('renewed', (key, newToken) => {
      setToken(key, newToken);
    });
  };
  const unSubscribeTokenManager = () => {
    var _tokenManager$off, _tokenManager$off2;
    tokenManager === null || tokenManager === void 0 ? void 0 : (_tokenManager$off = tokenManager.off) === null || _tokenManager$off === void 0 ? void 0 : _tokenManager$off.call(tokenManager, 'expired');
    tokenManager === null || tokenManager === void 0 ? void 0 : (_tokenManager$off2 = tokenManager.off) === null || _tokenManager$off2 === void 0 ? void 0 : _tokenManager$off2.call(tokenManager, 'renewed');
  };
  const allocateToken = async (scopes, newTokenKey) => {
    var _authService$_oktaAut2, _authService$_config, _newTokens$tokens;
    if (!scopes || scopes.length === 0) {
      const errorMsg = "scopes are not provided";
      error(errorMsg);
      return undefined;
    }
    if (!newTokenKey) {
      const errorMsg = "newTokenKey is not provided";
      error(errorMsg);
      return undefined;
    }
    const token = authService === null || authService === void 0 ? void 0 : (_authService$_oktaAut2 = authService._oktaAuth) === null || _authService$_oktaAut2 === void 0 ? void 0 : _authService$_oktaAut2.token;
    const defaultScopes = authService === null || authService === void 0 ? void 0 : (_authService$_config = authService._config) === null || _authService$_config === void 0 ? void 0 : _authService$_config.scope;
    scopes = uniq(_concatInstanceProperty(defaultScopes).call(defaultScopes, scopes));
    const newTokens = await token.getWithoutPrompt({
      scopes
    });
    const accessTokenWrapper = newTokens === null || newTokens === void 0 ? void 0 : (_newTokens$tokens = newTokens.tokens) === null || _newTokens$tokens === void 0 ? void 0 : _newTokens$tokens.accessToken;
    setToken(newTokenKey, accessTokenWrapper === null || accessTokenWrapper === void 0 ? void 0 : accessTokenWrapper.accessToken);
    tokenManager.add(newTokenKey, accessTokenWrapper);
    return getTokenByKey(newTokenKey);
  };
  const login = async (fromUri, additionalParams = {}) => {
    const loginRedirectFallBack = "".concat(window.location.pathname).concat(window.location.search).replace(basenameUri, '');
    let loginUri = isString(fromUri) ? fromUri : getConfigValue('JUTRO_AUTH_LOGIN_REDIRECT_PATH', loginRedirectFallBack);
    if (_includesInstanceProperty(loginUri).call(loginUri, '/logout')) {
      loginUri = '/';
    }
    const idp = getConfigValue('JUTRO_AUTH_IDP');
    const params = _objectSpread({}, idp ? {
      idp
    } : idp, {}, additionalParams);
    await authService.login("".concat(basenameUri).concat(loginUri), params);
  };
  const logout = async fromUri => {
    const logoutUri = isString(fromUri) ? fromUri : getConfigValue('JUTRO_AUTH_LOGOUT_REDIRECT_PATH', '/logout');
    return authService.logout("".concat(basenameUri).concat(logoutUri)).catch(err => {
      const errorCode = err.errorCode;
      const errorMsg = "Jutro Auth logout failure: ".concat(errorCode);
      error(errorMsg);
      if (errorCode !== OKTA_NOT_FOUND) {
        throw new Error(errorMsg);
      }
    });
  };
  const getAccessToken = () => {
    return authService.getAccessToken();
  };
  const getIdToken = () => {
    return authService.getIdToken();
  };
  const returnNull = () => null;
  const decodeFunction = (authService === null || authService === void 0 ? void 0 : (_authService$_oktaAut3 = authService._oktaAuth) === null || _authService$_oktaAut3 === void 0 ? void 0 : (_authService$_oktaAut4 = _authService$_oktaAut3.token) === null || _authService$_oktaAut4 === void 0 ? void 0 : _authService$_oktaAut4.decode) || returnNull;
  const decodeToken = token => {
    const decoder = decodeFunction;
    return decoder(token);
  };
  const getDecodedIdToken = async () => {
    const token = await getIdToken();
    return decodeToken(token);
  };
  const getDecodedAccessToken = async () => {
    const token = await getAccessToken();
    return decodeToken(token);
  };
  const getAuth = () => {
    return _objectSpread({}, authState, {
      authenticated: authState.isAuthenticated,
      tokenManager,
      allocateToken,
      decodeToken,
      getAccessToken,
      getDecodedIdToken,
      getDecodedAccessToken,
      getIdToken,
      login,
      logout
    });
  };
  return React.createElement(AuthContext.Provider, {
    value: getAuth()
  }, children);
};
AuthContextProvider.displayName = 'AuthContextProvider';
AuthContextProvider.__docgenInfo = {
  componentName: "AuthContextProvider",
  packageName: "@jutro/auth",
  description: "AuthContextProvider",
  displayName: "AuthContextProvider",
  methods: [],
  actualName: "AuthContextProvider"
};